import { takeEvery, put, takeLatest } from "redux-saga/effects";
import api from "../../services/api";
import { ENDPOINT } from '../../services/apiUrls';
import {
  getBusinessData, getBusinessBranchesData, getInventoryBranchesData, saveBusinessBranchesData, getUserDataObj,
  saveUserData, saveBusinessData, saveInventoryBranchesData, getAllBrands, saveAllBrandsData,
  getAllChannels, saveAllChannelsData, getBranchesGroupData, saveBranchesGroupData, getLicencesForBusiness, saveLicencesForBusiness, getInventorySuppliers, saveInventorySuppliers
} from '../slices';

export interface ResponseGenerator {
  config?: any,
  data?: any,
  headers?: any,
  request?: any,
  status?: number,
  statusText?: string,
  code?: string
}

function* fetchBusinessData() {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.BUSINESS.getBusinessData()
    })
    yield put(saveBusinessData(response))
  } catch (error) {
    console.log(error);
  }
}

function* fetchUserData(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: 'GET',
      url: ENDPOINT.BUSINESS.getUserData()
    })
    yield put(saveUserData(response))
    let errorCodes = ['IDLE_TIMEOUT', 'UNAUTHENTICATED_USER', 'REST_LICENCE_OPERATION_FAILED', 'REST_STALE_CLIENT_VERSION'];
    if (response?.code && errorCodes.indexOf(response?.code) !== -1) { // user unauthenticated
      actions.payload.callback && actions.payload.callback(false);
    } else {
      actions.payload.callback && actions.payload.callback(response); // user authenticated
    }
  } catch (error) {
    console.log(error);
  }
}

function* fetchBusinessBranchesData() {
  try {
    const response: ResponseGenerator = yield api.request({
      method: 'POST',
      url: ENDPOINT.BUSINESS.getBusinessBranches()
    })
    yield put(saveBusinessBranchesData(response))
  } catch (error) {
    console.log(error)
  }
}

function* fetchInventoryBranchesData() {
  try {
    const response: ResponseGenerator = yield api.request({
      method: 'POST',
      url: ENDPOINT.BUSINESS.getInventoryBranches()
    })
    yield put(saveInventoryBranchesData(response))
  } catch (error) {
    console.log(error)
  }
}

function* fetchInventorySuppliersData() {
  try {
    const response: ResponseGenerator = yield api.request({
      method: 'POST',
      url: ENDPOINT.BUSINESS.getInventorySuppliers()
    })
    yield put(saveInventorySuppliers(response))
  } catch (error) {
    console.log(error)
  }
}

function* fetchAllBrandsData() {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.BUSINESS.getBrandsApi
    })
    yield put(saveAllBrandsData(response))
  } catch (error) {
    console.log(error);
  }
}

function* fetchAllChannelsData() {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.BUSINESS.getChannelsApi
    })
    yield put(saveAllChannelsData(response))
  } catch (error) {
    console.log(error);
  }
}

function* fetchBranchGroupData() {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.BUSINESS.getBranchGroupApi
    })
    yield put(saveBranchesGroupData(response))
  } catch (error) {
    console.log(error);
  }
}

function* fetchLicenses() {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.BUSINESS.getLicencesForBusiness()
    })
    if(!response.code)
      yield put(saveLicencesForBusiness(response))
  } catch (error) {
    console.log(error);
  }
}


export default function* root() {
  yield takeLatest(getLicencesForBusiness.type, fetchLicenses);
  yield takeEvery(getBusinessData.type, fetchBusinessData);
  yield takeEvery(getUserDataObj.type, fetchUserData);
  yield takeEvery(getBusinessBranchesData.type, fetchBusinessBranchesData);
  yield takeEvery(getInventoryBranchesData.type, fetchInventoryBranchesData);
  yield takeEvery(getBranchesGroupData.type, fetchBranchGroupData);
  yield takeEvery(getAllChannels.type, fetchAllChannelsData);
  yield takeEvery(getAllBrands.type, fetchAllBrandsData);
  yield takeLatest(getInventorySuppliers.type, fetchInventorySuppliersData);

}

